import { handleActions } from 'redux-actions';
import { createSelector } from 'reselect';
import { GridFilters, initialStateList } from './GridFiltersReducer';
import SubMerchantsType from '../types/SubMerchantsType';

const initialState = {
  pspMerchantsList: { ...initialStateList },
  subMerchantsList: { ...initialStateList },
  subMerchantDetailList: { ...initialStateList },
};

export const SubMerchants = handleActions(
  {
    ...GridFilters,
    [SubMerchantsType.actions.fetchCountriesSuccess]: (state, { payload }) => {
      return {
        ...state,
        countries: payload,
      };
    },
    [SubMerchantsType.actions.fetchPspMerchantsDataSuccess]: (state, { payload: { pspMerchantsList } }) => {
      return {
        ...state,
        pspMerchantsList,
      };
    },
    [SubMerchantsType.actions.fetchSubMerchantsFiltersSuccess]: (state, { payload: { subMerchantsList } }) => {
      return {
        ...state,
        subMerchantsList,
      };
    },
    [SubMerchantsType.actions.fetchSubMerchantsDetailsSuccess]: (state, { payload: { subMerchantDetailList } }) => {
      return {
        ...state,
        subMerchantDetailList,
      };
    },
    [SubMerchantsType.actions.clearSubMerchantsList]: (state) => {
      return {
        ...state,
        subMerchantsList: { ...initialStateList },
      };
    },
    [SubMerchantsType.actions.clearSubMerchantsDetails]: (state) => {
      return {
        ...state,
        subMerchantDetailList: { ...initialStateList },
      };
    },
  },
  {
  ...initialState,
  countries: []
}
);

const getSubMerchants = (state) => state.SubMerchants;

export const getPspmerchantsList = (state, list) => {
  const pspMerchantsList = getSubMerchants(state) || [];
  return pspMerchantsList[list] ? pspMerchantsList[list] : [];
};

export const getSubmerchantsList = (state, list) => {
  const subMerchantsList = getSubMerchants(state) || [];
  return subMerchantsList[list] ? subMerchantsList[list] : [];
};

export const getSubmerchantCountries = (state) => {
  const subMerchantsCountries = getSubMerchants(state) || [];
  return subMerchantsCountries.countries ? subMerchantsCountries.countries : [];
};

export const getSubmerchantDetailList = (state, list) => {
  const subMerchantDetailList = getSubMerchants(state) || [];
  return subMerchantDetailList[list] ? subMerchantDetailList[list] : [];
};


export const getSubMerchantsData = createSelector(getSubMerchants, (state) => state.getSubMerchantData);

export const getSubMerchantsDetails = createSelector(getSubMerchants, (state) => state.getSubMerchantsDetails);

export const getSubMerchantsCountries = createSelector(getSubMerchants, (state) => {
  return state.countries;
});
